export const CoreTextResourceEnglish: { [key: string]: any }= {
  language: 'en',
  text: {
    minutes: 'minutes',
    tile: {
      services: 'services',
      service: 'service'
    },
    loading: {
      start: 'loading scheduler',
      cancel: 'Waiting for cancellation',
      service: 'Loading branch services',
      calendar: 'Loading time slots available'
    },
    modal: {
      timeout: 'Your session will restart in {{ countdown }} seconds.',
      navigation: 'Navigating away from the scheduler will erase all entered data. Continue?',
      here: 'I am still here',
      goodbye: 'Goodbye',
      cancel: 'Are you sure you want to cancel this appointment?',
      yes: 'Yes',
      no: 'No'
    },
    breadcrumbs:{
      yourAppointment: 'Schedule Appointment',
      branch: 'Schedule Appointment',
      service: 'Schedule Appointment - Step {{actualStep}} of {{totalStep}}',
    },
    title: {
      branch: 'Select a Location',
      service: {
        1: 'How Can We Help You?',
        2: 'Select Date and Time',
        3: 'Your Contact Info',
        final: 'Your Appointment'
      },
      checkIn: 'Check In',
      yourAppointment: {
        queue: 'You are in, {{firstname}}!',
        original: 'Your Appointment',
        checkIn: 'You are in, {{firstname}}!'
      }
    },
    search: {
      branch: 'Search location',
      service: 'Search service',
    },
    noFound: {
      branch: {
        title: "No locations found",
        content: "Try a different keyword."
      },
      service: {
        title: "No services found",
        content: "Try a different keyword."
      }
    },
    information: {
      cancel: {
        title: 'Appointment canceled',
        content: 'Your appointment was canceled.',
        button: [
          {
            title: 'Schedule an appointment',
            action: '/',
            type: 'primary'
          }
        ]
      },
      submit: {
        title: 'Something went wrong',
        content: 'We were unable to complete your request. Please try again later.',
        button: [
          {
            title: 'Schedule an appointment',
            action: '/',
            type: 'primary'
          }
        ]
      },
      server: {
        title: 'Scheduler unavailable',
        content: 'Scheduler is currently unavailable. Please try again later or for assistance, contact your branch for assistance.'
      },
      noavailability: {
        title: 'No appointments available',
        content: 'Please select a different day or location.'
      },
      noserviceforlanguage: {
        title: 'Service Not Available',
        content: 'This service is not available at this location with the language selected. Please select a different language or location to continue.'
      },
      wrongTimeLate: {
        title: 'Check-in not available',
        content: 'It looks like you are arriving too late for your appointment (originally scheduled on {{time}}). We may still be able to assist you today as a walk-in or reach out to a team member for further assistance.',
        button: [
          {
            title: 'WALK-IN',
            type: 'primary',
            action: '/services/{{branchID}}'
          },
          {
            title: 'Close',
            type: 'secondary',
            action: '/splash'
          }
        ]
      },
      wrongTimeEarly: {
        title: 'Sorry, {{firstname}}. Wrong Date.',
        content: 'It looks like your appointment was scheduled at the {{branch}} branch at {{time}}. We may still be able to assist you today as a walk-in or reach out to a team member for further assistance.',
        button: [
          {
            title: 'WALK-IN',
            type: 'primary',
            action: '/services/{{branchID}}'
          },
          {
            title: 'Close',
            type: 'secondary',
            action: '/splash'
          }
        ]
      },
      wrongDate: {
        title: 'Check-in not available',
        content: 'It looks like your appointment was scheduled at the {{branch}} branch at {{time}}. We may still be able to assist you today as a walk-in or reach out to a team member for further assistance.',
        button: [
          {
            title: 'WALK-IN',
            type: 'primary',
            action: '/services/{{branchID}}'
          },
          {
            title: 'Close',
            type: 'secondary',
            action: '/splash'
          }
        ]
      },
      wrongLocation: {
        title: 'Sorry, {{firstname}}. You\'re in a different location.',
        content: 'It looks like your appointment was scheduled at the {{branch}} branch at {{time}}. We may still be able to assist you here as a walk-in or reach out to a team member for further assistance.',
        button: [
          {
            title: 'WALK-IN',
            type: 'primary',
            action: '/services/{{branchID}}'
          },
          {
            title: 'Close',
            type: 'secondary',
            action: '/splash'
          }
        ]
      },
      notAvailable: {
        title: 'Appointment time no longer available',
        content: 'The appointment time you have selected is no longer available.',
        button: [
          {
            title: 'Schedule new timeslot',
            action: '/calendar',
            type: 'primary'
          }
        ]
      },
      expired: {
        title: 'Appointment Not Available',
        content: 'The appointment you inquired is no longer available or does not exist.',
        button: [
          {
            title: 'Schedule an appointment',
            action: '/',
            type: 'primary'
          }
        ]
      },
      session: {
        title: 'Session Expired',
        content: 'Please scan the QR code displayed on the kiosk and try again.'
      },
      wrongBranch: {
        title: 'Location not available.',
        content: 'The location is invalid or not available.',
        button: [
          {
            title: 'Choose a different location',
            action: '/branches-location',
            type: 'primary'
          }
        ]
      },
      wrongService: {
        title: 'Service not available.',
        content: 'The service selected is invalid or not available.',
        button: [
          {
            title: 'Choose a different service',
            action: '/services/branchID',
            type: 'primary'
          }
        ]
      }
    },
    page:{
      clear: 'Clear',
      back: 'back',
      checkIn: {
        body: 'Enter the email or phone number you used when scheduling your appointment.',
        banner: {
          error : {
            title: 'Error: We could not find an appointment with the information you provided.',
            content: 'Verify information and try again, or reach out to a team member for further assistance.'
          },
          force : {
            title: 'Error: enter a valid email or phone number to continue.'
          },
          system : {
            title: 'Something went wrong while checking your appointment.',
            content: 'Please try again, or reach out to a team member for further assistance.'
          }
        },
        form: {
          email: {
            label:'Email',
            placeholder: 'Enter email',
            error: 'Error: Enter a valid email address'
          },
          phone: {
            label: 'Mobile Phone',
            placeholder: 'Enter mobile phone number',
            error: 'Error: Enter a 10-digit number.'
          },
          submit: 'Submit'
        }
      },
      branch: {
        input: {
          search: 'Search location'
        },
        side: {
          title: 'Find your nearest location',
          content: 'Visit our Locations page to find one of our 25+ branches near you.',
          link: 'Locations'
        }
      },
      service: {
        main: {
          input: {
            search: 'Search service'
          },
          research: 'Categories'
        },
        side: {
          steps: ['Service', 'Date & Time', 'Info'],
          location: 'Choose different location',
          notSelected: 'not specified'
        }
      },
      calendar: {
        none: 'none',
        morning: 'Morning',
        afternoon: 'Afternoon',
        convertTime: {
          'America/New_York': 'Eastern Time',
          'America/Chicago': 'Central Time'
        },
        timeZone: 'All times are in (UTC-0{{hourDiff}}:00) {{timezone}} (US & Canada).',
        days: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
        months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        input: {
          allMember: 'All available team members'
        },
        bannerWarning: {
          title: 'The staff requested is invalid or not available.',
        }
      },
      splash: {
        welcome: 'Welcome to ',
        subText: 'We are so glad you are here. Let\'s get started by selecting from below:',
        button: {
          walkin: 'WALK-IN<br>( Join the queue )',
          checkin: 'CHECK-IN<br>( I have an appointment )'
        },
        info: {
          title: 'Walk-in Alert: High traffic volume this time.',
          description: 'A team member will reach out to you for an estimated wait time after you join the queue.'
        },
        side: {
          title: 'Check-in or join the queue from your own device',
          content: 'Scan code with your iOS or Android device.'
        }
      },
      contactInfo: {
        banner: {
          error : {
            title: 'Error: One or more fields above are invalid. Correct issue to continue.',
            content: ''
          }
        },
        form: {
          fullname: {
            label:'Full name',
            placeholder: 'Enter full name',
            error: 'Error: Enter first and last name.'
          },
          email: {
            label:'Email',
            placeholder: 'Enter email',
            error: 'Error: Enter a valid email address'
          },
          phone: {
            label: 'Mobile number',
            placeholder: 'Enter mobile number',
            error: 'Error: Enter a 10-digit phone number.'
          },
          appointment: {
            label: 'Receive appointment notifications via text message',
            placeholder: 'Standard messaging rates may apply.',
            error: ''
          },
          membership: {
            label: 'Membership number (optional)',
            placeholder: 'Enter membership number',
            error: 'Error: Enter your membership/account number (up to 10 digits).'
          },
          detail: {
            label: 'Additional details (optional)',
            placeholder: 'Enter additional details',
            error: ''
          },
          submit: 'Submit'
        },
        legal: `
          <div>
            By using Addition Financial Credit Union's Online Scheduler, you agree to the collection of your personal information, including your name, phone number, and email address. This information will be used solely for scheduling and follow-up purposes related to your appointment. We value your privacy and safeguarding your personal data. Your information will not be shared with third parties, except as required by law or as necessary to provide you with the services you requested. We use reasonable security measures to protect your personal information and to prevent unauthorized access or disclosure. For more details on how we collect, use, and protect your data, please refer to our <a href="https://pages.additionfi.com/hubfs/Disclosures/Privacy%20Notice.pdf" target="_blank" rel="noopener noreferrer" class="text-afcu-navy-800 font-semibold">Privacy Notice</a>. If you have questions, please contact us directly.
          </div>
          <div>
            By proceeding with Addition Financial's Online Scheduler, you acknowledge and accept this privacy disclosure.
          </div>
          <div>
            We look forward to welcoming you for your appointment. During your appointment, we will ask you to verify or update your contact information. Ensuring your name, address and other contact information are correct helps us prevent fraud.
          </div>
        `
      },
      yourAppointment: {
        titles: {
          location: 'Location',
          service: 'Service',
          info: 'Your Contact Info',
          dateTime: 'Date & Time',
          calendarAdd: 'Add to Calendar',
          cancel: 'Cancel appointment',
          serviceDetails: 'Service Details',
          additionalDetails: 'Additional Details',
          done: 'Done',
          closing: 'Auto-closing in ',
          seconds: 'seconds'
        },
        banner: {
          success : {
            title: 'Your appointment has been scheduled!'
          },
          queue: {
            success : {
              title: 'You are number [queue placement number] in the queue.'
            },
            warning: {
              title: 'We look forward to assisting you.',
              content: 'Please be advised that we are experiencing long wait times. A team member will be with you shortly.'
            }
          },
          checkin: {
            success : {
              title: 'A team member will be with you shortly.'
            },
            warning: {
              early: {
                title: 'We look forward to assisting you.',
                content: 'Please be advised that you have arrived a bit earlier than expected. A team member will be with you shortly.'
              },
              late: {
                title: 'We look forward to assisting you.',
                content: 'Please be advised that late arrival may delay the rendering of services. A team member will be with you shortly.'
              }
            }
          }
        }
      }
    },
    footer: {
      disclaimer: 'Addition Financial Credit Union is federally insured by the National Credit Union Administration.',
      copyright: 'Copyright &copy; 2025 Addition Financial Credit Union.'
    }
  }
}